import Image from 'next/image';

import { Box, Typography } from '@mui/material';

import { colors } from 'theme';

export interface IAboutItemProps {
    srcImg: string;
    title: string;
    body: string;
}

export function AboutItem(props: IAboutItemProps) {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                height: '100%',
                width: '100%',
                padding: '20px',
                // cursor: 'pointer',
                // '&:hover': {
                //     border: `1px solid ${colors.secondary}`,
                //     borderRadius: '10px',
                //     boxShadow: '0px 0px 16px 0px #DBD1C9CC',
                // },
            }}
        >
            <Box>
                <Image
                    width={'45'}
                    height={'45'}
                    src={props.srcImg}
                    alt="book_icon"
                />
            </Box>
            <Box>
                <Typography
                    variant="body1"
                    sx={{
                        fontWeight: 'bold',
                        textAlign: 'center',
                        color: colors.primary,
                    }}
                >
                    {props.title}
                </Typography>
            </Box>
            {/* <Box>
                <Typography
                    variant="body2"
                    sx={{
                        color: '#361500',
                        textAlign: 'justify',
                    }}
                >
                    {props.body.substring(0, 50)} ...
                </Typography>
                <Typography
                    variant="body2"
                    mt={1}
                    color={colors.secondary}
                    textAlign={'center'}
                >
                    عرض المزيد
                </Typography>
            </Box> */}
        </Box>
    );
}
